import React from "react";
import ProjectPageComponent from "../../../../project-components/ProjectPageComponent";

import ApplicationSection from "../all/sections/ApplicationSection";
import BannerSection from "../all/sections/BannerSection";
import UnfinishedHomeNewsFeed from "../../../components/parts/news/UnfinishedHomeNewsFeed";
import DefaultPage from "project-components/pages/DefaultPage";

class AlumniPage extends ProjectPageComponent {

	componentDidMount() {
		this.scrollTop()
	}

	componentDidUpdate() {
		this.scrollTop()
	}

	render() {
		return (
			<>
				<DefaultPage
					title="ศิษย์เก่า"
					leftSide={
						<>
							<UnfinishedHomeNewsFeed news_category_ids={[7]} />
						</>
					}
					rightSide={
						<>
							<ApplicationSection groupId={6}/>
							<BannerSection categoryId={6} tail={"?fromLink=/th/student&fromText=นักศึกษา"} />
							{/*<BannerSection categoryId={2} tail={"?fromLink=/th/student&fromText=นักศึกษา"} />*/}
						</>
					}
				/>
			</>
		);
	}

}

export default AlumniPage;
